// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { useVariableDetector, VariableDetector } from '@/ui';
import { CheckIcon } from '@/icons';
import { Form, Modal, ModalSize } from '@/components';
import { StyledButton, StyledButtons } from './EditModalStyles';
import BrandContent from '../BrandContent/BrandContent';
import BrandSeo from '../BrandContent/BrandSeo';
import Tabs from 'src/shared/ui/Tabs/Tabs';

// Models
import { IBrand } from '@/models/brands.model';

// Helpers
import { normalizeInitialValues, TUpdateBrandFormValues } from '../../helpers';

type TEditModal = {
  visible: boolean;
  handleClose: () => void;
  onSubmit: (values: TUpdateBrandFormValues) => void;
  initialValues?: IBrand;
};

const EditModal = ({ visible, handleClose, onSubmit, initialValues }: TEditModal) => {
  const { t } = useTranslation();
  const { variables, selectVariableInInput, registerInputRef, handleInputChange } = useVariableDetector();

  if (!initialValues) return null;

  return (
    <Modal visible={visible} onCancel={handleClose} footer={null} title={t('brand_image')} size={ModalSize.LARGE}>
      <VariableDetector variables={variables} onSelectVariable={selectVariableInInput} />
      <Form onFinish={onSubmit} initialValues={normalizeInitialValues(initialValues)}>
        <Tabs
          defaultActiveKey={'content'}
          items={[
            {
              label: t('content'),
              key: 'content',
              children: <BrandContent registerInputRef={registerInputRef} handleInputChange={handleInputChange} />,
            },
            {
              label: t('menu_seo'),
              key: 'seo',
              children: <BrandSeo />,
            },
          ]}
        />

        <StyledButtons>
          <StyledButton type="primary" htmlType="submit" icon={<CheckIcon />}>
            {t('btn_save')}
          </StyledButton>
        </StyledButtons>
      </Form>
    </Modal>
  );
};

export default EditModal;
